<!--  -->
<template>
<footer class="footer">
    <div class="container">
        <!-- <div class="footer-content">
            <div class="footer-section">
                <h3 class="footer-title">关于我们</h3>
                <p style="color: #b3b3b3;">我们是一家专注于棋牌运动推广与发展的创新企业，致力于搭建行业交流平台，推动棋牌运动规范化、竞技化发展。</p>
            </div>
            
            <div class="footer-section">
                <h3 class="footer-title">快速链接</h3>
                <ul class="footer-links">
                    <li><a href="#">首页</a></li>
                    <li><a href="#">关于我们</a></li>
                        <li><a href="#">合作伙伴</a></li>
                        <li><a href="#">赛事活动</a></li>
                        <li><a href="#">联系我们</a></li>
                    </ul>
                </div>
                
                <div class="footer-section">
                    <h3 class="footer-title">联系我们</h3>
                    <div class="footer-contact">
                        <p><i class="fas fa-map-marker-alt"></i> 北京市朝阳区棋牌大厦A座12层</p>
                        <p><i class="fas fa-phone"></i> 400-123-4567</p>
                        <p><i class="fas fa-envelope"></i> partnership@example.com</p>
                    </div>
                </div>
        </div> -->
            
        <div class="copyright">
            <p>Copyright &copy; 2024&nbsp;&nbsp;ICP备案号 苏ICP备2024102048号-1 &nbsp;&nbsp;All Rights Revered.</p>
        </div>
        </div>
    </footer>

</template>

<script>
export default {
data() {
return {

}
},
created() {

},
mounted() {

},
methods: {

}
}
</script>
<style lang='scss' scoped>
 .footer {
        background: #1a1a2e;
        color: white;
        padding: 60px 0 40px;
    }
    
    .footer-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 40px;
    }
    
    .footer-section {
        flex: 1;
        min-width: 250px;
    }
    
    .footer-title {
        font-size: 1.4rem;
        margin-bottom: 25px;
        color: #fff;
        position: relative;
        padding-bottom: 10px;
    }
    
    .footer-title:after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 50px;
        height: 3px;
        background: #3498db;
    }
    
    .footer-links {
        list-style: none;
    }
    
    .footer-links li {
        margin-bottom: 12px;
    }
    
    .footer-links a {
        color: #b3b3b3;
        text-decoration: none;
        transition: color 0.3s ease;
    }
    
    .footer-links a:hover {
        color: #3498db;
    }
    
    .footer-contact p {
        margin-bottom: 15px;
        color: #b3b3b3;
    }
    
    .footer-contact i {
        margin-right: 10px;
        color: #3498db;
        width: 20px;
    }
    
    .copyright {
        text-align: center;
        padding-top: 40px;
        margin-top: 40px;
        border-top: 1px solid rgba(255, 255, 255, 0.1);
        color: #b3b3b3;
        font-size: 0.9rem;
    }
    
    /* 响应式设计 */
    @media (max-width: 992px) {
        .header h1 {
            font-size: 2.5rem;
        }
        
        .stat-item {
            min-width: 180px;
            padding: 20px;
        }
        
        .partners-grid {
            grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        }
    }
    
    @media (max-width: 768px) {
        .header h1 {
            font-size: 2.2rem;
        }
        
        .header-subtitle {
            font-size: 1.1rem;
            padding: 0 15px;
        }
        
        .stats-container {
            gap: 20px;
        }
        
        .stat-item {
            min-width: 150px;
            padding: 15px;
        }
        
        .stat-number {
            font-size: 2.2rem;
        }
        
        .description-title, .section-title {
            font-size: 1.8rem;
        }
        
        .partners-grid {
            grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
            gap: 20px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue